import {transparentize} from 'polished';
import styled from 'styled-components';
import {accentColorPrim, accentColorSecond, white} from "../../../../assets/styledAssets/vars";

export const StyledSliderWrap = styled.div`
  width: 100%;
  .k-slider{
    width: 100%;
    &.k-state-focused{
      .k-draghandle{
        box-shadow: 0 3px 4px 0 ${transparentize(0.4, accentColorPrim)};
      }
    }
  }
  .k-slider-track{
    background-color: ${accentColorSecond};
  }
  .k-slider-selection,
  .k-draghandle,
  .k-draghandle:hover,
  .k-draghandle:focus{
    background-color: ${accentColorPrim};
  }
  .k-draghandle,
  .k-draghandle:hover,
  .k-draghandle:focus{
    border:2px solid ${white};
  }
  .k-tick{
    background-color: ${white};
    border: 2px solid ${accentColorPrim};
    border-radius:50%;
    width:2rem!important;
    height:2rem;
    background-image:none;
    transform: scale(.7) translateY(4px);
  }
  .k-label{
    font-size:1.8rem;
    margin-bottom: -1rem;
  }
`;
